import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import TbhLogoWithText from '../../common/TbhLogoWithText';
import PaymentModal from '../../components/global/PaymentGatewayModal';
import * as BsIcons from 'react-icons/bs';
import * as CgIcons from 'react-icons/cg';
import axios from 'axios';
import { baseUrl_, dashboardPageUrl } from '../../utils/constants';
import { decryptJson } from '../../utils/decryptJson';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import customToast, { ToastType } from '../../components_/Toast';
import { Request } from '../../apis/request';

const iconStyle = { color: '#028789', width: '50px', height: '50px' };
const iconDangerStyle = { color: 'red', width: '50px', height: '50px' };
const iconPendingStyle = { color: 'yellow', width: '50px', height: '50px' };

const FlutterwavPaymentCompleted = () => {
  const location = useLocation();
  const ss = location.search;
  const paymentArr = ss.slice(1).replace('status=', '').split('&');
  const status = paymentArr[0];
  const tx_ref = paymentArr[1].replace('tx_ref=', '');
  const transaction_id = paymentArr[2].replace('transaction_id=', '');

  const [paymentSuccess, setPaymentSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const token = localStorage.getItem('login-token');
  useEffect(() => {
    setLoading(true);
    Request.get(`/verify/flutterwave-transaction/${transaction_id}`, {
      headers: {
        sessId: localStorage.getItem('sessId') ?? '',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setLoading(false);
        const decrypted = decryptJson(res?.data?.data);
        setPaymentSuccess(decrypted?.status);
      })
      .catch((err: any) => {
        err?.response?.data?.message && customToast(err?.response?.data?.message, ToastType.error);
        setLoading(false);
      });
  }, []);

  const clicc = () => {
    window.localStorage.setItem('payment-success', 'true');
    window.dispatchEvent(new Event('storage'));
    setTimeout(() => {
      window.open(`${dashboardPageUrl}/dashboard`, '_top');
    });
  };

  return (
    <>
      {loading ? (
        <div className='w-full flex flex-col items-center h-screen py-10 px-12'>
          <TbhLogoWithText />
          <div className='flex justify-center'>
            <ClipLoader color={'#F8B400'} loading={loading} size={30} className='mt-[30px]' />
          </div>
        </div>
      ) : (
        <>
          <div className='w-full flex flex-col items-center h-screen py-10 px-12'>
            {/* <Link to='/'> */}
            <TbhLogoWithText />
            {/* </Link> */}
            <div className='flex flex-col items-center p-[20px] w-[100%] max-w-[400px] mt-[50px] bg-[white] rounded-[6px]'>
              {paymentSuccess === 'successful' ? (
                <BsIcons.BsCheck2Circle style={iconStyle} />
              ) : paymentSuccess === 'failed' ? (
                <CgIcons.CgDanger style={iconDangerStyle} />
              ) : (
                <BsIcons.BsInfoCircle style={iconPendingStyle} />
              )}
              <section className='mt-[20px] font-Poppins font-semibold text-[12px] sm:text-lg text-center'>
                {paymentSuccess === 'successful'
                  ? 'Your payment was successful'
                  : paymentSuccess === 'failed'
                  ? 'Your payment failed'
                  : "Your payment is pending, you'll receive a notification via email once it's been processed"}
              </section>

              {paymentSuccess === 'failed' ? (
                <button
                  onClick={() => setShow(true)}
                  className='w-[200px] !h-[40px] bg-[#028789] text-[white] font-Poppins font-normal text-[13px] rounded-md mt-[20px]'
                >
                  Try Again
                </button>
              ) : (
                <div onClick={() => clicc()}>
                  <button className='w-[200px] !h-[40px] bg-[#028789] text-[white] font-Poppins font-normal text-[13px] rounded-md mt-[10px]'>
                    Proceed
                  </button>
                </div>
              )}
            </div>
          </div>

          <PaymentModal show={show} setShow={setShow} />
        </>
      )}
    </>
  );
};

export default FlutterwavPaymentCompleted;
